const colors = {
  text: "#000",
  background: "#000",
  secondaryText: "#333333",
  lightText: "#CCC2BA",
  lightGreen: "#D5E0B8",
  darkGreen: "#004C26",
  darkBlue: "#2B2148",
  lightYellow: "#F7E8A1",
  darkBrown: "#42210B",
}

const breakpoints = ["640px", "768px", "1024px", "1280px", "1440px"]

const space = ["5px", "10px", "20px", "40px"]

export const preset = {
  colors,
  breakpoints,
  space,
  fonts: {
    body: "Funkis",
    secondary: "PitchSans",
  },
  body: {
    fontFamily: "body",
    letterSpacing: "-0.03em",
    lineHeight: "1.25",
    fontWeight: "normal",
  },
  secondary: {
    fontFamily: "PitchSans",
    letterSpacing: "-0.03em",
    lineHeight: "1.33",
    fontWeight: "normal",
  },
  styles: {
    body: {
      margin: 0,
      padding: 0,
    },
    hr: {
      color: "#333",
      borderBottom: "0.5px solid",
    },
    button: {
      color: "inherit",
    },
  },
}
export default preset
